import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function TopLists() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Explore curated top lists of luxury trains on First-Class.com. Discover the most exceptional train journeys and experiences around the globe'
          }
        />
        <title>Train Toplists: Ranking the Best Luxury Train Routes</title>
      </Head>
      <ArticlesList
        subtype="Toplists"
        type="Trains"
        heading="Finest Selection"
      />
    </>
  );
}

export default withLayout(TopLists, true);
